module.exports = __webpack_public_path__ + "images/179_160.jpg";